import React from "react";
import { User, UserType } from "@common/types/user";
import { UserAvatar } from "@components/avatar/UserAvatar";
import { KickAvatar } from "@components/avatar/KickAvatar";
import { KICK_ACTOR_LABEL, KICK_SUPPORT_LABEL } from "@common/constants/actor";
import { DOCUMENT_SOURCE_INTEGRATIONS } from "@components/history/components/integrationActors";
import { InstitutionIcon } from "@design-system/InstitutionIcon/InstitutionIcon";

export function findIntegrationBySource(source: string) {
    return DOCUMENT_SOURCE_INTEGRATIONS.find(
        (i) => i.documentSource === source,
    );
}

type IntegrationMatch = ReturnType<typeof findIntegrationBySource>;

export function getUploaderLabel(
    uploader: User | null,
    integration: IntegrationMatch,
): string {
    if (integration) {
        return integration.label;
    }

    switch (uploader?.type) {
        case UserType.REGULAR:
        case UserType.DEMO:
        case UserType.DEMO_FAKE:
            return uploader.name ?? KICK_ACTOR_LABEL;
        case UserType.SUPPORT:
            return KICK_SUPPORT_LABEL;
        case undefined:
        default:
            return KICK_ACTOR_LABEL;
    }
}

export function renderUploaderIcon(
    uploader: User | null,
    integration: IntegrationMatch,
): React.ReactNode {
    if (integration) {
        return (
            <InstitutionIcon
                institution={integration.institution}
                size="sm"
                label={integration.label}
            />
        );
    }

    switch (uploader?.type) {
        case UserType.REGULAR:
        case UserType.DEMO:
        case UserType.DEMO_FAKE:
            return <UserAvatar user={uploader} size="sm" />;
        case UserType.SUPPORT:
        case undefined:
        default:
            return <KickAvatar size="sm" />;
    }
}
